import { Capacitor } from '@capacitor/core';

// True only when the app is opened from a developer's machine or LAN. False on any
// deployed host (invexis.co.in, Amplify previews) and in the native app, whose
// WebView also reports the hostname "localhost".
export const isLocalDevHost = () => {
  if (Capacitor.isNativePlatform()) return false;
  const host = window.location.hostname;
  return host === 'localhost'
    || host === '127.0.0.1'
    || /^10\./.test(host)
    || /^192\.168\./.test(host)
    || /^172\.(1[6-9]|2\d|3[0-1])\./.test(host);
};
